// extracted by mini-css-extract-plugin
export default {"Container":"ReportedUser_Container__8e7OA","Posts":"ReportedUser_Posts__OxRKJ"};